export const fetchAddressByCep = (cep: string) => {
  return fetch(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => response.json())
    .then((data) => {
      if (data.erro) return null;
      
      return {
        cep: data.cep.replace(/\D/g, ""),
        endereco: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        estado: data.uf || "",
        numero: "",
        complemento: "",
      };
    })
    .catch(() => null); // Retorna null em caso de erro
};
